import * as React from "react";
const B1Fill = (props) => (
  <svg
    width={24}
    height={26}
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.0457 0.5C7.54475 0.5 7.94931 0.90456 7.94931 1.40361V5.01805C7.94931 5.5171 7.54475 5.92166 7.0457 5.92166C6.54665 5.92166 6.14209 5.5171 6.14209 5.01805V1.40361C6.14209 0.90456 6.54665 0.5 7.0457 0.5Z"
      fill="#276AA6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2771 0.5C16.7762 0.5 17.1808 0.90456 17.1808 1.40361V5.01805C17.1808 5.5171 16.7762 5.92166 16.2771 5.92166C15.7781 5.92166 15.3735 5.5171 15.3735 5.01805V1.40361C15.3735 0.90456 15.7781 0.5 16.2771 0.5Z"
      fill="#276AA6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.812 4.73125C18.812 3.73125 19.9565 3.16499 20.7517 3.75535C22.1613 4.82763 23.077 6.50233 23.077 8.41798V12.6949V13.195V17.8296C23.077 18.3819 22.6293 18.8296 22.077 18.8296H1.18555C0.633262 18.8296 0.185547 18.3819 0.185547 17.8296V13.195V12.6949V8.41798C0.185547 8.24931 0.197595 8.08063 0.209643 7.91196C0.221691 7.76738 0.233739 7.63485 0.257836 7.50232C0.281932 7.3216 0.318076 7.14088 0.366269 6.9722C0.414462 6.79148 0.462654 6.61076 0.534943 6.43004C0.541686 6.41318 0.547486 6.39726 0.553134 6.38176C0.567669 6.34188 0.581202 6.30475 0.607232 6.26136C0.655424 6.10474 0.727713 5.96016 0.800002 5.81558C0.800002 5.79149 0.81205 5.77944 0.836146 5.75534C0.920483 5.58667 1.01687 5.40595 1.1253 5.24932C1.13735 5.22522 1.1494 5.21317 1.16145 5.20113C1.25783 5.0445 1.36626 4.88788 1.49879 4.7433C1.7518 4.418 2.05301 4.11679 2.39036 3.85174C2.40843 3.83366 2.42951 3.8186 2.4506 3.80354C2.47168 3.78848 2.49276 3.77342 2.51084 3.75535C2.55903 3.71921 2.59517 3.69511 2.64337 3.67101C2.64939 3.66499 2.65541 3.66198 2.66144 3.65897C2.66746 3.65595 2.67349 3.65294 2.67951 3.64692C3.46264 3.24933 4.45059 3.80354 4.45059 4.73125V4.85173C4.45059 5.82763 4.93251 6.74329 5.69155 7.27341C5.79998 7.34569 5.92045 7.40593 6.04093 7.46617L6.04094 7.46618C6.16142 7.52642 6.2819 7.57461 6.40238 7.61075C6.54696 7.65895 6.70359 7.69509 6.87226 7.70714C7.06503 7.73124 7.2578 7.73124 7.45057 7.70714C7.61925 7.69509 7.77587 7.65895 7.92045 7.61075C8.05298 7.57461 8.17346 7.52642 8.28189 7.46618L8.2819 7.46617C8.40238 7.40593 8.52286 7.34569 8.63129 7.27341C9.37827 6.80353 9.87225 5.96016 9.87225 5.00836V3.75535C9.87225 3.0927 10.4144 2.55054 11.0771 2.55054H12.1855C12.8481 2.55054 13.3903 3.0927 13.3903 3.75535V5.00836C13.3903 6.59871 14.7638 7.87581 16.3903 7.70714C17.7999 7.56256 18.812 6.26136 18.812 4.85173V4.73125Z"
      fill="#276AA6"
    />
    <path
      d="M21.9753 20.1987C22.5658 20.1987 23.0346 20.7124 22.8686 21.2791C22.1541 23.7187 19.9016 25.4999 17.2338 25.4999H6.07723C3.40943 25.4999 1.15692 23.7187 0.442444 21.2791C0.276476 20.7124 0.74526 20.1987 1.33576 20.1987H21.9753Z"
      fill="#276AA6"
    />
    <path
      d="M8.43604 12.8243L10.838 15.2264L15.055 11.0095"
      stroke="white"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default B1Fill;
